import React, { useRef, useEffect, useState } from 'react';
import paper from 'paper';
import ProgressBar from '../ProgressBar';

export const Crumple = ({
  colors = [ 'white' ],
  strokeWidth = 2,
  count = 100,
  crumpleX = 200,
  crumpleY = 100,
  canvasBackgroundColor = 'transparent',
  documentBackgroundColor = 'black',
  bend = 200,
  fillColor = 'white',
  barColor = 'rgba(255,255,255,0.45)',
  texts = [
    {
      text: 'Sample 1',
      count: 100,
      fontSize: 50,
    },
    {
      text: 'An then 2',
      count: 200,
      fontSize: 100,
    },
    {
      text: 'Finally 3',
      count: 300,
      fontSize: 300,
    }
  ],
  content = {
    justification: 'center',
    fontSize: texts[0].fontSize,
  }
}) => {

  const canvasRef = useRef(null);
  const barRef = useRef({ index: 0, counter: 0 });
  const [barProgress, setBarProgress] = useState({ index: 0, counter: 0 });

  useEffect(() => {
    paper.setup(canvasRef.current);

    const displayText = new paper.PointText({
      point: [paper.view.size.width/2, paper.view.size.height/2],
      content: texts[0].text,
      ...content,
    });
    displayText.fillColor = fillColor;

    // Create overlapping curves
    const curves = [];
    for (let i = 0; i < count; i++) {
      const curve = new paper.Path();
      curve.strokeColor = colors[i] || colors[0] || 'black';
      curve.strokeWidth = strokeWidth;

      for (let j = 0; j < 500; j++) {
        curve.add(new paper.Point(j * crumpleX, i * crumpleY));
      }

      curves.push(curve);
    }

    const onMouseMove = (event) => {
      document.body.style.backgroundColor = documentBackgroundColor;

      const bar = barRef.current;
      if (bar.index < texts.length - 1) bar.counter += 1;
      if (bar.counter > texts[bar.index].count) {
        bar.index += 1;
        displayText.content = texts[bar.index].text;
        displayText.fontSize = texts[bar.index].fontSize;
      }
      setBarProgress({ index: bar.index, counter: bar.counter });

      const mousePoint = event.point;
      displayText.point = mousePoint;

      for (let i = 0; i < curves.length; i++) {
        const curve = curves[i];
        for (let j = 0; j < curve.segments.length; j++) {
          const segment = curve.segments[j];
          const distance = segment.point.getDistance(mousePoint);
          const bendFactor = bend / (distance + 1);
          const direction = segment.point.subtract(mousePoint).normalize();
          segment.point = segment.point.subtract(direction.multiply(bendFactor));
        }
      }
    };

    const onMouseLeave = (event) => {
      document.body.style.backgroundColor = 'white';
      document.body.style.transition = 'background-color 1s';
    };

    const onMouseDown = (event) => {
      for (let i = 0; i < curves.length; i++) {
        curves[i].strokeWidth = strokeWidth / 2;
      }
    };

    const onMouseUp = (event) => {
      for (let i = 0; i < curves.length; i++) {
        curves[i].strokeWidth = strokeWidth;
      }
    };

    paper.view.on('mousemove', onMouseMove);
    paper.view.on('mouseleave', onMouseLeave);
    paper.view.on('mousedown', onMouseDown);
    paper.view.on('mouseup', onMouseUp);

    return () => {
      paper.view.off('mousemove', onMouseMove);
      paper.view.off('mouseleave', onMouseLeave);
      paper.view.off('mousedown', onMouseDown);
      paper.view.off('mouseup', onMouseUp);
      paper.project.clear();
    };
  }, []);

  return (
    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
      <canvas ref={canvasRef} style={{ width: '100%', height: '100%', backgroundColor: canvasBackgroundColor }} />
      <ProgressBar
        texts={texts}
        index={barProgress.index}
        counter={barProgress.counter}
        color={barColor}
      />
    </div>
  );
};

export default Crumple;
